import { supabase } from '../client'
import type { BidInsert } from '../../types'

export async function addBid(bidInsert: BidInsert) {
  const { data, error } = await supabase.from('bids').insert(bidInsert).select()
  return { data, error }
}
